var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCause2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 270.15 217.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6d7082;}.cls-2{fill:#2f3546;}.cls-3{fill:#fff;}.cls-4{fill:#03c897;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:#f2f2f2;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.76,46.64c-.45-1-40.31,101.29-40.31,101.29s9.56,6.72,13.69,8.52,33.08,14.22,47.8,16.54,48.32-1,56.07-3.62,61.76-24,61.76-24l-46.51-100s-21.45,7.23-27.65,8.78-31.26,1.29-37.72.52S89.79,49,88.76,46.64Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.1,2.17s11.86-1,14,5C271,15.36,270,25.24,270,25.24V204.82s-1.91,10-7,11.23-249,1.24-249,1.24-12.92,1-13.34-16.21C.08,178.6,0,14.64,0,14.64S.64,1.54,11.43.29,254.1,2.17,254.1,2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.63,15.46s10.52-.91,12.4,4.37c2.56,7.18,1.7,15.82,1.7,15.82V192.82s-1.7,8.73-6.21,9.82-221,1.09-221,1.09-11.47.91-11.84-14.19c-.49-19.67-.57-163.17-.57-163.17s.57-11.46,10.15-12.55S239.63,15.46,239.63,15.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "163.95 27 164.47 31.14 234.75 30.1 234.23 26.74 163.95 27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "206.32 37.6 206.06 40.7 234.75 40.95 234.49 37.34 206.32 37.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.13,26l4.91.51v6.46h6.72v6l-6.2-.78-.78,7.24s-4.91.77-4.91,0-.77-7.24-.77-7.24l-5.69.26V33.2l5.69-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41,27s2.33,0,2.07,1.81-1,5.43-1.81,5.43-16.79-1.81-16.79-1.81-3.1-4.39-1-5.17S41,27,41,27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.62,39.15s1.29-3.1,2.07-3.36,2.58-1,3.36,0S37.34,43,37.34,43l.26,53s0,.6-1.9,1.12-4.31-.52-4.48-1.38S30.62,39.15,30.62,39.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.83,98.75s14.81,0,15.5.34a2.85,2.85,0,0,1,1.21,2.76c-.35.86-1.55,3.44-2.07,3.27s-15.33-1.55-15.33-1.55-1.89-1.55-1.55-2.76S26.83,98.75,26.83,98.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.31,108.52s1.89-1.93,2.93-1.93S36.65,108.3,37,110c.72,3.57.34,3.65.17,68.05,0,0,.18,3.65-.86,4.72s-5,.43-5.16-1.07S31.31,108.52,31.31,108.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.62,186.43s15.16-.69,16.2-.35,1.89.52,1.55,2.24-1.38,2.93-1.9,2.93-14.12.17-15.16,0S24.25,187.29,25.62,186.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.13,185c-1.5.53-3.1.69-3.27,2.07s.17,4.13,1.55,4.65,2.92,1.55,4,.86a5.2,5.2,0,0,0,2.41-3.27C82,187.89,80.06,183.93,77.13,185Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.81,184.62A3.86,3.86,0,0,0,84.36,186c-.69,1-1.37,2.58-1,3.61a4.63,4.63,0,0,0,3.27,2.59c1.38.17,3.28-.52,3.79-1.38s1.21-2.76.69-3.79S88.33,184.79,87.81,184.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.63,185.14c-1.55,0-3.79.86-4.14,1.89s-.51,3.1.52,4.13,2.76,2.07,4,1.56a4.28,4.28,0,0,0,2.59-2.24,16.09,16.09,0,0,0,.34-3.45S98.32,185.14,97.63,185.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.31,185.31c-.87-.66-3.45-.69-4.14.17a7.44,7.44,0,0,0-1.2,3.45,3.51,3.51,0,0,0,2.24,3.44c1.38.35,3.44-.86,4.3-1.72s1.38-1.9.87-2.93A7.25,7.25,0,0,0,108.31,185.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.92,185.31a3.29,3.29,0,0,0-3.44.86c-.69.86-1.38,2.58-.87,3.62s1.21,2.24,2.42,2.41,3.44.52,4.13-.69a4,4,0,0,0,.69-3.45A3.93,3.93,0,0,0,116.92,185.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.08,185.14a4.9,4.9,0,0,0-4,.86,5.24,5.24,0,0,0-1.2,3.79c.17.86,1.89,2.93,3.44,2.93s3.1-.52,3.62-1.73.86-1.72.34-3.27A5.64,5.64,0,0,0,127.08,185.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M135,185.14c-1.85.52-2.93.17-3.27,1.72s-.69,3.62,0,4.13a9.61,9.61,0,0,0,4.13,1.21c1.21,0,3.27-.86,3.27-2.07s.52-2.07-.34-3.27S136.21,184.79,135,185.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "206.32 166.36 206.32 169.46 234.57 169.81 234.4 166.19 206.32 166.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "205.89 172.39 205.72 175.83 234.66 175.66 234.32 172.91 205.89 172.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.76,181.86l-.34,3.28,19.81.17.17-3.1S214.59,182.55,214.76,181.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "214.16 187.89 214.33 191.51 234.32 191.68 234.32 188.58 214.16 187.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.76,46.64c-.45-1-40.31,101.29-40.31,101.29s9.56,6.72,13.69,8.52,33.08,14.22,47.8,16.54,48.32-1,56.07-3.62,61.76-24,61.76-24l-46.51-100s-21.45,7.23-27.65,8.78-31.26,1.29-37.72.52S89.79,49,88.76,46.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.11,71.84a27,27,0,0,0-5.91-2.54c-8.31-2.48-17.42-2.42-26-2.06-19.9.84-47.63,6.18-62.13,20.82C76.23,99,72.51,105.75,70.56,114.82c-2.15,10-1.42,20.55,4.18,29.16C81.36,154.15,94,158,105.24,160.36c19.31,4,39.6,3.08,56.79-7.27a77.6,77.6,0,0,0,32.13-39.2C199.79,98.85,195,79.83,181.11,71.84Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 233.33,
    cy: 68.13,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 233.33,
    cy: 74.37,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 233.33,
    cy: 79.63,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 233.33,
    cy: 84.83,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 233.33,
    cy: 90.01,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 233.33,
    cy: 95.24,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 233.33,
    cy: 100.85,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 233.33,
    cy: 105.89,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 233.33,
    cy: 111.3,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 233.33,
    cy: 116.95,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 233.33,
    cy: 122.58,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 233.33,
    cy: 127.92,
    r: 1.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.68,13.05c-2-5.66-13.1-4.69-13.1-4.69S29.24,5.44,19.12,6.61,8.4,20.08,8.4,20.08s.08,154,.59,175.14c.4,16.2,12.51,15.23,12.51,15.23s228.66,0,233.42-1.17,6.55-10.55,6.55-10.55V30S262.39,20.76,259.68,13.05Zm-6.32,23.44v155.4s-1.68,8.63-6.16,9.71-219.46,1.08-219.46,1.08-11.39.9-11.76-14c-.49-19.45-.56-161.33-.56-161.33S16,16,25.5,14.91s213.87,1.61,213.87,1.61,10.45-.89,12.31,4.32C254.23,28,253.36,36.49,253.36,36.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161.15,141.58l-14,12.09-11-4-6.88-3.39s-7-3-9.58-8-4.79-15.86-5.12-17.43-.51-17.24.23-18.46,1.5-1.91,2.33-1a3.9,3.9,0,0,1,1.2,3.38c-.2,1.46.47,7.49.38,8.42s-.12,6.2,1.19,6.14,1.67-4,1.67-4,.38-21.11.55-23.09-.3-6.71.44-7.93S124,82,125,82.17s1.83,2.69,1.83,2.69l-.06,7.38.44,15.79s1.68,2.3,2.09-.35.75-13.85.75-13.85.46-15.33,1.47-16.3a4.43,4.43,0,0,1,3-.79l.66,16.61s-.78,13.18-.1,13.68a1.35,1.35,0,0,0,2.19-1.16c.06-1.58.3-17,.3-17s.89-9.53,1.89-10.76,2.65.41,2.65.41.23,11.06,0,12.39-1.61,14.17-.51,15.18,1.7-.21,1.88-2.07.75-12.81.95-14.14.21-4.36,1.5-4.81,2.36,2.53,2.36,2.53l-.06,25.31.27,18a5.12,5.12,0,0,0,2.56,4.1C153.53,136.25,161.15,141.58,161.15,141.58Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCause2);
export default __webpack_public_path__ + "static/media/cause_2.9281f34ba4dfa39393be930f78ade5d4.svg";
export { ForwardRef as ReactComponent };